import * as React from "react";
import { connect, Provider } from "react-redux";
import { withRouter } from "react-router-dom";
import { duplicateSearch, mergeReports, clearResults } from "./redux-objects/actions";
import DataTable from "../DataTable";
import moment from "moment";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import { Button } from "react-bootstrap";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { DateRangePicker } from "react-dates";
import ReactDOM from "react-dom";
import * as urls from "../shared/urls";
import * as documentDownloadService from "../../services/documentDownloadService";
import { getTableValuesByGroupName } from "../../services/Utils/IndexedDBUtils";
import Select from "react-select";
import { toast } from "react-toastify";
import CommentModal from "../CommentModal/CommentModal";
import { addAdminLog } from "../AuditLogs/adminLog";
import { UserInfo } from "../Login/common/defaults";
import { IAuditLogBase, IDriver, IReport, IVehicle } from "../../common/sharedTypes";
import { showLoadingWithMessage } from "../Application/redux-objects/actions";
import Api from "../../services/Api";
import "./duplicateSearch.scss";
import { ApiResponse } from "apisauce";
import { ElasticIndices, LogCategoryEnum, LoggingLevel } from "../../services/Enums/shared";
import { createManagementAuditLog } from "../WorkflowQueues/Management/redux-objects/actions";
import ViewAllButton from "../DocumentViewer/ViewAllButton";
import Store from "../../store/Store";
import rootReducer from "../../store/Reducers";
import { QueueStartDate } from "../WorkflowQueues/common";

const reduxStore = Store({}, rootReducer);

const $ = require("jquery");
$.DataTable = require("datatables.net-bs4");
$.fn.dataTable.ext.errMode = "none";

export interface IDuplicateSearchActionProps {
  duplicateSearch?: (url: string) => void;
  mergeReports?: (url: string, reportId1: number, reportId2: number) => Promise<void>;
  createManagementAuditLog: (managementLog: IAuditLogBase, value: any) => void;
  clearResults: () => void;
}

interface IDuplicateSearchStateProps {
  webServiceURL: string;
  searchResults: IReport[];
  elasticSearchURL: string;
  currentUser: UserInfo;
  showLoadingWithMessage: (show: boolean, message?: string) => void;
}

interface IDuplicateSearchProps extends IDuplicateSearchActionProps, IDuplicateSearchStateProps { }

const initialState = {
  startDate: moment(QueueStartDate),
  endDate: moment(),
  focusedInput: null,
  crashKey: "",
  //duplicateLocationChkbx: false,
  duplicateDriversLicenseNumberChkbx: false,
  driversLicenseNumber: "",
  firstName: "",
  lastName: "",
  isGetingImage: false,
  countyId: "",
  counties: [],
  countyOption: {},
  showCommentModal: false,
  comment: "",
  pendingAction: "",
  loading: false,
  data: [],
  isMergeDisabled: true,
  isDeleteSelectedDisabled: true,
};

type DuplicateSearchState = Readonly<typeof initialState>;

class DuplicateSearch extends React.Component<IDuplicateSearchProps, DuplicateSearchState> {
  private dataTableRef: React.MutableRefObject<DataTable>;

  public constructor(props: IDuplicateSearchProps) {
    super(props);
    this.state = initialState;
    this.dataTableRef = React.createRef();
  }

  componentDidMount() {
    if (this.state.counties.length === 0) {
      getTableValuesByGroupName("County").then((results) => this.setState({ counties: results }));
    }

    this.dataTableRef.current?.currentTable.on('select', this.onResultGridSelect);
    this.dataTableRef.current?.currentTable.on('deselect', this.onResultGridSelect);
  }

  componentDidUpdate() {
    if (this.state.loading) {
      setInterval(() => {
        if (this.state.data == this.props.searchResults) {
          this.props.showLoadingWithMessage(
            true,
            "Loading potential duplicate reports - please wait"
          );
        } else {
          this.setState({ loading: false });
          this.props.showLoadingWithMessage(false);
        }
      }, 1000);
    }
  }

  componentDidUnmount() {
    this.dataTableRef.current?.currentTable.off('select', this.onResultGridSelect);
    this.dataTableRef.current?.currentTable.off('deselect', this.onResultGridSelect);
  }

  setDisabledButtons = (rows: any[]) => {
    this.setState({
      isMergeDisabled: rows.length !== 2,
      isDeleteSelectedDisabled: rows.length === 0,
    });
  }

  onResultGridSelect = (e, dt, type, indexes) => {
    const selectedRows: any[] = dt.rows('.selected').data();
    this.setDisabledButtons(selectedRows);
  }

  doSearch() {
    this.props.clearResults();
    this.setDisabledButtons([]);

    let uri = this.props.webServiceURL + urls.DUPLICATE_SEARCH;
    let params = {
      //duplicateLocation: this.state.duplicateLocationChkbx,
      duplicateDriversLicenseNumber: this.state.duplicateDriversLicenseNumberChkbx,
      crashKey: this.state.crashKey,
      startDate: this.state.startDate.toDate().toUTCString(),
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      endDate: this.state.endDate.toDate().toUTCString(),
      county: this.state.countyId,
      driversLicenseNumber: this.state.driversLicenseNumber,
    };

    const esc = encodeURIComponent;
    const query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");

    uri = uri + "?" + query;
    this.props.duplicateSearch(uri);
    this.setState({ data: this.props.searchResults });
    this.setState({ loading: true });
    this.componentDidUpdate();
  }

  handleOpenImage(event: React.MouseEvent<HTMLElement>, row: any) {
    const crashId = event;
    documentDownloadService.openOnBaseImage(crashId, null);
    console.log("props after data loads", this.props);
  }

  handleSearchButton(event: React.MouseEvent<HTMLElement>) {
    this.doSearch();
  }

  handleMergeButton(event: React.MouseEvent<HTMLElement>) {
    const selected = $("#tblDuplicateSearch").DataTable().rows(".selected");

    if (selected.data().length != 2) {
      toast.error("Exactly 2 reports must be selected to merge");
      return;
    }
    if (selected.data().filter((x) => x.keywords.reportType.name === "Investigator").length > 1) {
      toast.error("Cannot merge two investigator reports");
      return;
    }
    this.setState({
      pendingAction: "merge",
      showCommentModal: true,
    });
  }
  cancelComment = () => {
    this.setState({
      comment: "",
      showCommentModal: false,
    });
  };

  getSelectedRows() {
    return $("#tblDuplicateSearch").DataTable().rows(".selected");
  }

  handleDeleteSelected() {
    const selected = $(this.getSelectedRows().data());

    if (selected.length === 0) {
      toast.warn("No reports selected to delete");
      return;
    }

    this.setState({
      pendingAction: "delete",
      showCommentModal: true,
    });
  }

  async doDelete() {
    const selected = $(this.getSelectedRows().data());

    this.setState({ loading: true });
    let errorCount = 0;
    let successCount = 0;
    let promises = [];

    selected.each(async (_index: number, report) => {
      const workflowItemId = report.workflowItems[0].id;

      promises.push(
        Api.post(urls.SET_ACTIVE_STATUS, {
          workflowItemId,
        }).then((response: ApiResponse<any>) => {
          if (!response.ok) {
            errorCount += 1;
          } else {
            successCount += 1;
            this.createManagementLog(report.id);
          }
        })
      );
    });

    // wait for all api calls to return before displaying messages about results
    await Promise.all(promises);

    if (errorCount > 0) {
      toast.error("One or more reports failed to delete");
    }

    if (successCount > 0) {
      toast.success(
        `Successfully deleted ${successCount > 1 ? `${successCount} reports` : `${successCount} report`
        }`
      );
    }

    this.doSearch();
  }

  async saveComment() {
    if (this.state.pendingAction === "merge") this.doMerge();
    if (this.state.pendingAction === "delete") {
      await this.doDelete();
    }

    this.setState({
      showCommentModal: false,
      pendingAction: "",
      comment: "",
    });
  }

  createManagementLog(reportId: number) {
    const newLog: IAuditLogBase = {
      elasticIndex: ElasticIndices.Administration,
      logCategory: LogCategoryEnum.StatusChange,
      logLevel: LoggingLevel.Audit,
    };

    const logData = {
      action: this.state.pendingAction,
      userComment: this.state.comment,
      reportId: reportId,
    };

    this.props.createManagementAuditLog(newLog, logData);
  }

  doMerge = () => {
    const selected = this.getSelectedRows();

    this.setState(
      {
        showCommentModal: false,
        pendingAction: "",
      },
      () => {
        const reports: Array<IReport> = selected.data();

        // investigator report should be the old report, otherwise old report is the report with the oldest crash key
        const oldReport =
          reports[0].keywords.reportType.name === "Investigator"
            ? reports[0]
            : reports[1].keywords.reportType.name === "Investigator"
              ? reports[1]
              : reports[0].keywords.crashKey < reports[1].keywords.crashKey
                ? reports[0]
                : reports[1];
        const newReport = reports[0].id === oldReport.id ? reports[1] : reports[0];

        this.props
          .mergeReports(urls.MERGE_REPORTS, newReport.id, oldReport.id)
          .then((result) => {
            const desc = `Merging ${newReport.keywords.crashKey} and ${oldReport.keywords.crashKey}`;

            // audit log
            addAdminLog(
              this.props.elasticSearchURL,
              "Reports Merged",
              desc,
              {},
              this.props.currentUser.username
            );

            toast.success("Reports Merged!");
            this.doSearch();
          })

          .catch((ex) => {
            console.error({ ex });
            const desc = `${ex.Message} -- ${ex.StackTraceString}`;

            addAdminLog(
              this.props.elasticSearchURL,
              "Error with Auto-Merge",
              desc,
              {},
              this.props.currentUser.username
            );

            toast.error("Error Merging!  Check admin logs for details");
          });
      }
    );
  };

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      this.setState({ startDate, endDate });
    }
  }

  async handleDuplicateDriversLicenseNumber(e: React.FormEvent) {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    this.setState({ duplicateDriversLicenseNumberChkbx: el.checked }, () => {
      this.doSearch();
    });
  }
  handleCrashKeyChange(e: React.FormEvent) {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    this.setState({ crashKey: el.value });
  }
  handleDriversLicenseNumberChange(e: React.FormEvent) {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    this.setState({ driversLicenseNumber: el.value });
  }
  handleFirstNameChange(e: React.FormEvent) {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    this.setState({ firstName: el.value });
  }
  handleLastNameChange(e: React.FormEvent) {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    this.setState({ lastName: el.value });
  }
  handleCountyChange = (e: any) => {
    if (e != null) {
      this.setState({
        countyId: e.value,
        countyOption: e,
      });
    } else {
      this.setState({
        countyId: "",
        countyOption: {},
      });
    }
  };
  handleChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    switch (el.dataset.field) {
      case "comment":
        this.setState({
          comment: el.value,
        });
        break;
      default:
        break;
    }
  };

  highlightMatchedDriversLicenseNumbers = (licenseNumbers: Array<string>) => {
    const driverLicenseMatches = licenseNumbers.filter(
      (licenseNumber) => licenseNumber === this.state.driversLicenseNumber
    );

    return (
      <ul style={{ padding: 0 }}>
        {licenseNumbers.map((license) => (
          <li key={license}>
            <span
              className={
                driverLicenseMatches.some((match) => match === license) ? "match" : "nomatch"
              }
            >
              {license}
            </span>
          </li>
        ))}
      </ul>
    );
  };

  highlightMatchedDriverNames = (driverNames: Array<{ firstName: string; lastName: string }>) => {
    const lastNameMatches = driverNames.filter((name) => name.lastName === this.state.lastName);
    const firstNameMatches = driverNames.filter((name) => name.firstName === this.state.firstName);

    return (
      <ul style={{ padding: 0 }}>
        {driverNames.map((name, i) => (
          <li key={`${name}${i}`}>
            <span className={lastNameMatches.some((match) => match === name) ? "match" : "nomatch"}>
              {name.lastName || ""}
            </span>
            {name.lastName == "" || name.firstName == "" ? "" : ","}&nbsp;
            <span
              className={firstNameMatches.some((match) => match === name) ? "match" : "nomatch"}
            >
              {name.firstName || ""}
            </span>
            &nbsp;
          </li>
        ))}
      </ul>
    );
  };

  public render() {
    const columnDefs = [
      {
        targets: 0, // available actions
        width: "250px",
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div>
              <Provider store={reduxStore}>
                <ViewAllButton reportId={rowData?.id} dbToSearch="private" />
              </Provider>
            </div>,
            td
          ),
      },
      {
        targets: 1, // drivers license numbers
        createdCell: (cell: Element, cellData: Array<string>) => {
          return ReactDOM.render(this.highlightMatchedDriversLicenseNumbers(cellData), cell);
        },
      },
      {
        targets: 2, // driver names
        createdCell: (cell: Element, cellData: Array<any>) => {
          return ReactDOM.render(this.highlightMatchedDriverNames(cellData), cell);
        },
      },
      {
        targets: 3, // crash date
        render: function (data) {
          return moment(data).format("MM/DD/YYYY");
        },
      },
    ];

    const columns = [
      {
        title: "Available Actions",
        data: "id",
      },
      {
        title: "Driver License Number",
        mData: (data: IReport) => {
          return data.crashReport.vehicle.map((vehicle) => {
            const driversLicenseNumber = vehicle?.driver?.driverInfo?.driversLicense?.number;

            return `${driversLicenseNumber || ""}`;
          });
        },
      },
      {
        title: "Driver Name",
        mData: (data: IReport, type: string) => {
          return data.crashReport.vehicle.map((vehicle) => {
            const driverOccupant = vehicle.occupant.find((o) => o.personInfo.personType === "01");
            const firstName = driverOccupant?.personInfo?.name?.firstName || "";
            const lastName = driverOccupant?.personInfo?.name?.lastName || "";

            switch (type) {
              case "sort":
                return lastName.toLowerCase();
              case "display":
                return `${firstName} ${lastName}`;
              default:
                return { firstName, lastName };
            }
          });
        },
      },
      {
        title: "Crash Date",
        data: "crashReport.generalInformation.crashDateTime",
      },
      {
        title: "Crash Key",
        data: "keywords.crashKey",
      },
      {
        title: "Report Type",
        data: "keywords.reportType.name",
      },
      {
        title: "Street Name",
        data: "crashReport.crashLocation.streetNameOrHighwayNumber",
      },
      {
        title: "County",
        data: "keywords.county.description",
      },
    ];
    const options = {
      dom: "frtipB",
    };

    return (
      <div className="DuplicateSearch">
        <h3 className="float-header">Duplicate Search</h3>
        <div className="float-child-div"></div>
        <div className="row"></div>
        <Form className="duplicateSearchForm">
          <Form.Group className="float-container">
            <Form.Check
              type="checkbox"
              label="Duplicate Drivers License Number"
              checked={this.state.duplicateDriversLicenseNumberChkbx}
              onChange={(e) => this.handleDuplicateDriversLicenseNumber(e)}
              className="duplicateDriversLicenseNumberCheckbox"
            />
            <Form.Row>
              <Form.Row className="searchCriteria">
                <Form.Group className="duplicateSearchStartDate">
                  <Form.Label>Crash Date</Form.Label>
                  <br />
                  <DateRangePicker
                    startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                    startDateId="duplicateSearchStartDate" // PropTypes.string.isRequired,
                    endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                    endDateId="duplicateSearchEndDate" // PropTypes.string.isRequired,
                    onDatesChange={({ startDate, endDate }) =>
                      this.handleDatesChanged(startDate, endDate)
                    } // PropTypes.func.isRequired,
                    focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                    onFocusChange={(focusedInput) => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                    isOutsideRange={() => false}
                    small={true}
                    block={false}
                    minimumNights={0}
                  />
                </Form.Group>
                <Form.Group as={Col} className="autoWidth">
                  <Form.Label>Crash Key</Form.Label>
                  <Form.Control
                    type="text"
                    value={this.state.crashKey}
                    onChange={(e) => this.handleCrashKeyChange(e)}
                  />
                </Form.Group>
                {this.state.counties && this.state.counties.length > 0 && (
                  <Form.Group as={Col} className="selectlist">
                    <Form.Label>County</Form.Label>
                    <Select
                      isClearable={true}
                      data-field="county"
                      placeholder={"Select a county"}
                      options={this.state.counties.map((county) => ({
                        label: county.name + " - " + county.description,
                        value: county.fips,
                      }))}
                      onChange={(e) => this.handleCountyChange(e)}
                      value={this.state.countyOption}
                    />
                  </Form.Group>
                )}
                <Form.Group as={Col} className="selectlist">
                  {" "}
                </Form.Group>
              </Form.Row>
            </Form.Row>
            <Form.Row className="personFormFields">
              <Form.Group as={Col}>
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.firstName}
                  onChange={(e) => this.handleFirstNameChange(e)}
                />
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.lastName}
                  onChange={(e) => this.handleLastNameChange(e)}
                />
              </Form.Group>
              <Form.Group as={Col} className="driversLicenseState">
                <Form.Label>Drivers License Number</Form.Label>
                <Form.Control
                  type="text"
                  value={this.state.driversLicenseNumber}
                  onChange={(e) => this.handleDriversLicenseNumberChange(e)}
                />
              </Form.Group>
              <Form.Group as={Col} className="selectlist">
                {" "}
              </Form.Group>
            </Form.Row>
            <Form.Row />
            <Form.Row>
              <Form.Group as={Col} controlId="searchButton">
                <Button variant="primary" onClick={(e) => this.handleSearchButton(e)}>
                  Search
                </Button>
                {"  "}
                <Button
                  variant="secondary"
                  onClick={(e) => this.handleMergeButton(e)}
                  disabled={this.state.isMergeDisabled}
                >
                  Auto-Merge Selected
                </Button>
                {"  "}
                <Button
                  variant="danger"
                  onClick={() => this.handleDeleteSelected()}
                  disabled={this.state.isDeleteSelectedDisabled}
                >
                  Delete Selected
                </Button>
              </Form.Group>
            </Form.Row>
          </Form.Group>
        </Form>
        <DataTable
          id="tblDuplicateSearch"
          data={this.props.searchResults}
          columns={columns}
          columnDefs={columnDefs}
          actionsColumn="first"
          searching={false}
          ref={this.dataTableRef}
          {...options}
        />
        <CommentModal
          comment={this.state.comment}
          show={this.state.showCommentModal}
          onCommentChange={this.handleChange}
          onCloseCommentModal={this.cancelComment}
          onCancel={this.cancelComment}
          onSave={() => this.saveComment()}
        />
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    searchResults: state.DuplicateSearch.results,
    elasticSearchURL: state.Application.elasticSearchURL,
    currentUser: state.Application.currentUser,
  };
}

const mapDispatchToProps = {
  duplicateSearch,
  mergeReports,
  showLoadingWithMessage,
  createManagementAuditLog,
  clearResults,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DuplicateSearch));
